<template>
  <div id="profile" class="container">
    <section>
      <div class="section-group">
        <div class="row">
          <div class="col-md-3">
            <div class="card">
              <div class="card-body box-profile">
                <div class="text-center">
                  <avatarVue
                    :src="customer.userLogoBig"
                    :size="100"
                  ></avatarVue>
                  <!-- <el-avatar
                    :src="customer.userLogoBig"
                    :size="100"
                  ></el-avatar> -->
                  <!-- <img
                    class="profile-user-img img-fluid img-circle"
                    :src="customer.userLogoBig"
                    alt="User profile picture"
                  /> -->
                </div>
                <h3 class="profile-username text-center mb-1">
                  {{ customer.displayName }}
                </h3>
                <p class="text-muted text-center">{{ customer.sgL_Myself }}</p>
              </div>
              <!-- /.card-body -->
              <div class="card-body">
                <ul>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerPublish' }">
                      <i class="fas fa-share fa-fw mr-1"></i>  {{ $t('Customer.customerMessage.customerPublish') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerFavorite' }"
                      ><i class="fas fa-bookmark fa-fw mr-1"></i>  {{ $t('Customer.customerMessage.customerFavorite') }}
                    </router-link>
                  </li>
                  <li class="profile-nav active">
                    <router-link :to="{ name: 'customerMessage' }"
                      ><i class="fas fa-comments fa-fw mr-1"></i>  {{ $t('Customer.customerMessage.customerPrivateMessage') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerInfo' }"
                      ><i class="fas fa-cog fa-fw mr-1"></i>  {{ $t('Customer.customerMessage.customerInfo') }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
          <div class="col-md-9 pl-md-4">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <ul class="nav nav-pills" v-if="countList != null">
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: isreciver == true }"
                          href="javascript:void(0);"
                          @click="showContent('reciver')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerMessage.reciver') }}<span class="count">{{
                            this.countList.notMsgCount
                          }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: isreciver != true }"
                          href="javascript:void(0);"
                          @click="showContent('sent')"
                          data-toggle="tab"
                          > {{ $t('Customer.customerMessage.sent') }}<span class="count">{{
                            this.countList.msgCount
                          }}</span></a
                        >
                      </li>
                    </ul>
                  </div>
                  <!-- Search bar -->
                  <div class="col-4">
                    <div class="search">
                      <el-input
                        :placeholder="$t('Customer.customerMessage.customesearchrPublish')"
                        suffix-icon="fas fa-search"
                        v-model="title"
                      ></el-input>
                    </div>
                  </div>
                  <!-- /.Search bar -->
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <!-- My Profile -->
                <div class="my-comment section-group">
                  <div class="row">
                    <div class="col-12">
                      <div class="card">
                        <div class="card-body p-0">
                          <el-table :data="reciverModel">
                            <el-table-column width="500" :label="$t('Customer.customerMessage.msg')">
                              <template slot-scope="scope">
                                <a :href="scope.row.clickUrl">{{
                                  scope.row.sgL_Msg_MContent
                                }}</a>
                              </template>
                            </el-table-column>
                            <el-table-column prop="sgL_ImageLogin" width="38">
                              <template slot-scope="scope">
                                <avatarVue
                                  :src="scope.row.sgL_ImageLogin"
                                ></avatarVue>
                                <!-- <el-avatar
                                  size="small"
                                  :src="scope.row.sgL_ImageLogin"
                                >
                                </el-avatar> -->
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="sgL_Mem_DisplayName"
                              :label="$t('Customer.customerMessage.user')"
                            >
                            </el-table-column>
                            <el-table-column
                              prop="sgL_Msg_MAddTimerI"
                              :label="$t('Customer.customerMessage.date')"
                              width="110"
                            ></el-table-column>
                            <el-table-column :label="$t('Customer.customerMessage.Controls')" width="110">
                              <template slot-scope="scoped">
                                <a :href="scoped.row.clickUrl" :title="$t('Customer.customerMessage.check')"
                                  ><i
                                    class="fa fa-eye fa-fw mx-2"
                                    aria-hidden="true"
                                  ></i
                                ></a>
                                <el-button
                                  icon="fa fa-trash-alt fa-fw mx-2"
                                  @click="deleteMsg(scoped.row.id)"
                                  type="danger"
                                  size="mini"
                                  v-show="type != 303"
                                  > {{ $t('Customer.customerMessage.del') }}</el-button
                                >
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-5">
                    <div class="col-12 col-sm-6 col-xs-4">
                      <!--  引用分页组件 -->
                      <pagination
                        v-if="getPageShow"
                        :currentPage="pageParams.currentPage"
                        :total="pageParams.total"
                        :limit="pageParams.limit"
                        :small="true"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                      />
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.nav-tabs-custom -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
    </section>
  </div>
</template>
<script>
import pagination from "../common/Page";
import avatarVue from "../common/avatar.vue";
export default {
  data() {
    return {
      isreciver: true,
      customer: null,
      title: null,
      countList: null,
      type: 303,
      reciverModel: null,
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
    };
  },
  watch: {
    type(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.handleCurrentChange(1);
        this.pageParams.limit = 12;
        this.pageParams.total = 0;
        this.getReciver();
      }
    },
    title(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.handleCurrentChange(1);
        this.getReciver();
      }
    },
  },
  components: {
    pagination,
    avatarVue,
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
    this.customer = this.$store.getters.getcustomer;
    this.getReciverMessagecountList();
    this.getReciver();
  },
  methods: {
    getReciver() {
      let params = {
        Type: this.type,
        SGL_Msg_MContent: this.title,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.common.reciverMessage(params).then((res) => {
        if (res.data.success) {
          this.reciverModel = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
          if (this.pageParams.total > 1) {
            this.pageParams.pageshow = true;
          }
        }
      });
    },
    getReciverMessagecountList() {
      let params = null;
      this.$api.common.getReciverMessagecountList(params).then((res) => {
        if (res.data.success) {
          this.countList = res.data.result;
        }
      });
    },
    deleteMsg(id) {
      let params = {
        Id: id,
      };
      this.$api.common.deleteMsg(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          if (this.isreciver == true) {
            this.type = 303;
          } else {
            this.type = 202;
          }
          this.getReciver();
        }
      });
    },
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getReciver();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getReciver();
    },
    showContent(type) {
      if (type == "reciver") {
        this.isreciver = true;
        this.type = 303;
      } else {
        this.isreciver = false;
        this.type = 202;
      }
    },
  },
  computed: {
    getPageShow() {
      return this.pageParams.pageshow;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Customer/customerMessage.vue